import Entity from 'utilities/entity';

class Export extends Entity {

}

export default new Export();
